import { Dispatch, SetStateAction, useState } from 'react';

import { useNavigate } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';

import { useApplicationContext } from 'context/ApplicationContext';
import { Store } from 'hooks/application/useQueryUser';

export type ChangeStoreShellProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    query: string;
    setQuery: Dispatch<SetStateAction<string>>;
    selectedStore: Store | null;
    setSelectedStore: Dispatch<SetStateAction<Store | null>>;
    onClickConfirm: () => void;
};

export function useChangeStore({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) {
    const [query, setQuery] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);
    const { setStore, store } = useApplicationContext();
    const [selectedStore, setSelectedStore] = useState<Store | null>(store);
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const onConfirmChange = () => {
        setStore(selectedStore!);

        navigate('/');

        setOpen(false);

        setSelectedStore(null);

        queryClient.resetQueries({
            predicate: (q) => {
                const [key] = q.queryKey;

                return !['client', 'user', 'permissions'].includes(key as string);
            },
        });
    };

    const onClickConfirm = () => {
        if (selectedStore?.idLoja !== store?.idLoja) {
            setOpenConfirm(true);
        } else {
            setOpen(false);
        }
    };

    return { query, setQuery, selectedStore, setSelectedStore, openConfirm, setOpenConfirm, onConfirmChange, onClickConfirm };
}
